<template>
    <div>
        <div
            v-if="modoVisualizacaoItens == 'tabela'"
            class="planilha-medicao-pdf-source"
        >
            <app-tabela
                idTabela="tblPlanilhaMedicao"
                :itens="itensOrdenados"
                :campos="camposTabelaAtivos"
                :bordered="false"
                :small="false"
            >
            <template slot="descricao" slot-scope="data">
                <span
                    class="col-subitem-limited"
                    :class="!data.valorUnitario ? 'font-weight-bold' : ''"
                >
                   {{ data.descricao }}
                </span>
            </template>

            <template slot="quantidadeContratada" slot-scope="data">
                <span v-if="!data.valorUnitario">-</span>
                <span v-else>{{ data.quantidadeContratada | decimal }}</span>
            </template>

            <template slot="quantidade" slot-scope="data">
                <span v-if="!data.valorUnitario">-</span>
                <template v-else>
                    <span>{{ data.quantidade | decimal }}</span>
                </template>
            </template>

            <template slot="quantidadeAcumulada" slot-scope="data">
                <span v-if="!data.valorUnitario">-</span>
                <span v-else>{{ data.quantidadeAnterior | decimal }}</span>
            </template>

            <template slot="valorUnitario" slot-scope="data">
                <span v-if="!data.valorUnitario">-</span>
                <span v-else>{{ data.valorUnitario | currency }}</span>
            </template>

            <template slot="valorUnitarioMaisPrimeiroReajuste" slot-scope="data">
                <span v-if="!data.valorUnitario">-</span>
                <span v-else>{{ data.valorUnitarioMaisPrimeiroReajuste | currency }}</span>
            </template>

            <template slot="valorFinanceiro" slot-scope="data">
                <span v-if="!data.valorUnitario">-</span>
                <span v-else>{{ data.valorFinanceiro | currency }}</span>
            </template>

            <template slot="valorTotal" slot-scope="data">
                <span v-if="!data.valorUnitario">
                    {{ totalPorItemAgrupador[data.itemBoletimMedicaoId] | currency }}
                </span>
                <span v-else>{{ data.valorTotal | currency }}</span>
            </template>

            <template slot="unidadeMedida" slot-scope="data">
                <span v-if="!data.valorUnitario">-</span>
                <span v-else>{{ data.unidadeMedidaDescricao || "-" }}</span>
            </template>

            <template slot="qtdeSaldo" slot-scope="data">
                <span v-if="!data.valorUnitario">-</span>
                <span v-else>{{ (data.quantidadeContratada - data.quantidadeAnterior - data.quantidade) | decimal }}</span>
            </template>

            <template slot="rSaldo" slot-scope="data">
                <span v-if="!data.valorUnitario">-</span>
                <span v-else>{{ ((data.quantidadeContratada - data.quantidadeAnterior - data.quantidade) * data.valorUnitario) | currency }}</span>
            </template>

            <template slot="percentualExecutado" slot-scope="data">
                <span v-if="!data.valorUnitario">-</span>
                <span v-else>{{ data.percentualExecutado | percentual }}</span>
            </template>

            <!-- coluna de ações será implementada futuramente -->
            <!-- <template slot="acoes" slot-scope="data">
                <span
            <template slot="acoes" slot-scope="data">
                <span
                    v-if="habilitarBotaoDevolverItem(data)"
                    @click.stop="devolverItem(data)"
                    class="mx-1"
                >
                    <i
                        class="text-warning fa fa-refresh icon-button"
                        title="Devolver item para correção"
                    ></i>
                </span>

                <span
                    v-if="habilitarBotaoAprovarItem(data)"
                    @click.stop="aprovarItem(data)"
                    class="mx-1"
                >
                    <i
                        class="text-success fa fa-check-circle-o icon-button"
                        title="Aprovar item"
                    ></i>
                </span>

                <span
                    v-if="mostrarIconeStatusItemBoletimMedicao(data)"
                    class="mx-1 font-weight-bold"
                >
                    <b-badge
                        variant="secondary"
                        v-b-tooltip.hover
                        :title="mensagemStatusItem(data)"
                        class="icon-button"
                    >
                        <i
                            class="fa fa-info"
                        ></i>
                    </b-badge>
                </span>

                <span
                    v-if="habilitarExclusaoItens"
                    class="text-danger mr-2"
                >
                    <i
                        class="fa fa-lg fa-trash icon-button"
                        title="Excluir"
                        @click.stop="confirmarExcluir(data.itemBoletimMedicaoId)"
                    ></i>
                </span>
            </template> -->
            </app-tabela>
        </div>

        <visualizacao-importacao-pdf-assinado
            :show="modoVisualizacaoItens == 'pdf'"
            :contratoId="boletimMedicao.contratoId || contrato.contratoId"
            :boletimMedicaoId="boletimMedicao.boletimMedicaoId"
            :documentoBoletimMedicao="documentoItensBoletimMedicaoParaFluxoPdf"
            :documento-para-atualizar="documentoMedicaoTipoAtual"
            :tipoAnexoBoletimMedicao="obterTipoAnexoBoletimMedicao()"
            :modoVisualizacao="modoVisualizacaoImportacaoPdfAssinado"
            :carregando="carregandoPdfParaAssinatura"
            :nome-arquivo-existente="nomeAnexoAssinadoAtual"
            @importacao-realizada="onImportacaoPdfAssinadoImportacaoRealizada"
        />

        <div
            v-show="gerandoPdfPlanilhaMedicao"
            ref="areaImpressaoPlanilhaMedicao"
            class="planilha-medicao-pdf-export"
        >
            <div class="planilha-medicao-pdf-header">
                <resumo-contratual
                    :contrato="contrato"
                    :boletimMedicao="boletimMedicao"
                    :valorTotalTodosBoletins="valorTotalTodosBoletins"
                    :fornecedorLogoUrl="fornecedorLogoUrl"
                />
            </div>

            <table id="tblPlanilhaMedicaoPdf" class="table table-striped table-hover b-table mb-0">
                <colgroup>
                    <col
                        v-for="campo in camposTabelaAtivos"
                        :key="campo.key"
                        :style="{ width: larguraColunaPdf(campo) }"
                    >
                </colgroup>
                <thead>
                    <tr>
                        <th
                            v-for="campo in camposTabelaAtivos"
                            :key="campo.key"
                            :class="classeCabecalhoPdf(campo)"
                        >
                            {{ campo.label }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in itensOrdenados"
                        :key="item.itemBoletimMedicaoId"
                    >
                        <td class="col-descricao-pdf" :class="!item.valorUnitario ? 'font-weight-bold' : ''">
                            {{ item.descricao }}
                        </td>
                        <td class="text-right text-nowrap">
                            <span v-if="!item.valorUnitario">-</span>
                            <span v-else>{{ item.unidadeMedidaDescricao || "-" }}</span>
                        </td>
                        <td class="text-right text-nowrap">
                            <span v-if="!item.valorUnitario">-</span>
                            <span v-else>{{ item.quantidadeContratada | decimal }}</span>
                        </td>
                        <td class="text-right text-nowrap">
                            <span v-if="!item.valorUnitario">-</span>
                            <span v-else>{{ item.valorUnitario | currency }}</span>
                        </td>
                        <td class="text-right text-nowrap">
                            <span v-if="!item.valorUnitario">-</span>
                            <span v-else>{{ item.valorFinanceiro | currency }}</span>
                        </td>
                        <td class="text-right text-nowrap">
                            <span v-if="!item.valorUnitario">-</span>
                            <span v-else>{{ item.quantidadeAnterior | decimal }}</span>
                        </td>
                        <td class="text-right text-nowrap">
                            <span v-if="!item.valorUnitario">-</span>
                            <span v-else>{{ item.quantidade | decimal }}</span>
                        </td>
                        <!-- Coluna será reativada depois que a demanda de Reajuste estiver pronta -->
                        <!-- <td class="text-right text-nowrap">
                            <span v-if="!item.valorUnitario">-</span>
                            <span v-else>{{ item.valorUnitarioMaisPrimeiroReajuste | currency }}</span>
                        </td> -->
                        <td class="text-right text-nowrap">
                            <span v-if="!item.valorUnitario">
                                {{ totalPorItemAgrupador[item.itemBoletimMedicaoId] | currency }}
                            </span>
                            <span v-else>{{ item.valorTotal | currency }}</span>
                        </td>
                        <td class="text-right text-nowrap">
                            <span v-if="!item.valorUnitario">-</span>
                            <span v-else>{{ (item.quantidadeContratada - item.quantidadeAnterior - item.quantidade) | decimal }}</span>
                        </td>
                        <td class="text-right text-nowrap">
                            <span v-if="!item.valorUnitario">-</span>
                            <span v-else>{{ ((item.quantidadeContratada - item.quantidadeAnterior - item.quantidade) * item.valorUnitario) | currency }}</span>
                        </td>
                        <td class="text-right text-nowrap">
                            <span v-if="!item.valorUnitario">-</span>
                            <span v-else>{{ item.percentualExecutado | percentual }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="signature-section">
                <div class="signature-box">
                    <div class="signature-label">Responsável pela Execução</div>
                </div>
                <div class="signature-box">
                    <div class="signature-label">Fiscal de Obras / SUAPE</div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row justify-content-start mt-3">
            <b-button
                v-if="modoVisualizacaoItens == 'tabela'"
                variant="warning"
                class="mr-2"
                @click="$emit('voltar')"
            >
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Voltar
            </b-button>

            <b-button v-if="modoVisualizacaoItens == 'pdf'"
                variant="warning"
                class="mr-2"
                @click="onVoltarFluxoPdfClick"
            >
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Voltar
            </b-button>

            <b-button
                v-if="modoVisualizacaoItens == 'pdf' && modoVisualizacaoImportacaoPdfAssinado == 'preview' && documentoItensBoletimMedicaoParaFluxoPdf"
                class="btn-blue-custom mr-2"
                @click="baixarPdf"
            >
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 9V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V9M3.66667 5.66667L7 9M7 9L10.3333 5.66667M7 9V1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Baixar PDF
            </b-button>

            <b-button
                v-if="mostrarBotaoAnexarPdfAssinado"
                class="btn-green-custom mr-2"
                @click="onProximaEtapaPdfClick"
            >
                <i class="fa fa-check mr-2"></i>
                Próxima Etapa
            </b-button>

            <btn-conclusao-etapa
                v-if="mostrarBotaoAprovarParaColetaAssinaturaFiscalTerceiro"
                :titulo="'Aprovar Boletim de Medição para Coleta da Assinatura do Fiscal Terceiro'"
                :textoBotao="'Enviar para Coleta da Assinatura do Fiscal Terceiro'"
                :mensagemConfirmacao="'Deseja realmente aprovar o Boletim de Medição?'"
                :iconeBotao="'fa-check'"
                :variantBotao="'success'"
                :etapa="etapaBoletimMedicaoEnum.AprovacaoParaColetaAssinaturaFiscalTerceiro"
                @concluirEtapa="$emit('concluirEtapa', $event)"
            />

            <b-button
                v-if="modoVisualizacaoItens == 'tabela' && podeGerarPdfParaAssinatura"
                class="btn-blue-custom mr-2"
                @click="onVisualizarFormatoPdfClick"
                :disabled="carregandoPdfParaAssinatura"
            >
                <i class="fa fa-print mr-2"></i>
                {{ textoBotaoFluxoAssinatura }}
            </b-button>

        </div>

        <modal-aprovar-item
            :itemBoletimMedicao="itemBoletimMedicaoSelecionado"
            :contratoId="contrato.contratoId"
            :mostrarModal="mostrarModalAprovarItem"
            @fecharModal="fecharModalAprovarItem"
        />

        <modal-devolver-item
            :itemBoletimMedicao="itemBoletimMedicaoSelecionado"
            :contratoId="contrato.contratoId"
            :mostrarModal="mostrarModalDevolverItem"
            @fecharModal="fecharModalDevolverItem"
        />
    </div>
</template>

<script>

import {
    statusBoletimMedicaoEnum,
    statusItemBoletimMedicaoEnum,
    tipoAnexoBoletimMedicaoEnum,
    etapaBoletimMedicaoEnum,
} from '../../BoletimMedicao.js';
import ModalAprovarItem from './itensMedicao/ModalAprovarItem.vue';
import ModalDevolverItem from './itensMedicao/ModalDevolverItem.vue';
import VisualizacaoImportacaoPdfAssinado from './itensMedicao/VisualizacaoImportacaoPdfAssinado.vue';
import BtnConclusaoEtapa from '../../componentes/BtnConclusaoEtapa.vue';
import ResumoContratual from '../ResumoContratual.vue';
import BoletimMedicaoServicos from '../../BoletimMedicaoServicos';

export default {
    components: {
        ModalAprovarItem,
        ModalDevolverItem,
        VisualizacaoImportacaoPdfAssinado,
        BtnConclusaoEtapa,
        ResumoContratual,
    },
    props: {
        contrato: {
            type: Object,
            default: null
        },

        boletimMedicao: {
            type: Object,
            default: () => {}
        },

        boletimEditavel: {
            type: Boolean,
            default: false
        },

        valorTotalTodosBoletins: {
            type: Number,
            default: 0
        },

        fornecedorLogoUrl: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            modoVisualizacaoItens: 'tabela',
            camposTabela: [
                {
                    key: 'descricao',
                    label: 'Item',
                    filterable: true,
                    sortable: false,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'unidadeMedida',
                    label: 'Unid. Medida',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-right text-nowrap'
                },
                {
                    key: 'quantidadeContratada',
                    label: 'Qtde. Contratada',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-right text-nowrap'
                },
                {
                    key: 'valorUnitario',
                    label: 'R$ Unitário',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-right text-nowrap'
                },
                {
                    key: 'valorFinanceiro',
                    label: 'R$ Financeiro',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-right text-nowrap'
                },
                {
                    key: 'quantidadeAcumulada',
                    label: 'Qtde. Acumulada',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-right text-nowrap'
                },
                {
                    key: 'quantidade',
                    label: 'Qtde. Executada',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-right text-nowrap'
                },
                // Coluna será reativada depois que a demanda de Reajuste estiver pronta
                // {
                //     key: 'valorUnitarioMaisPrimeiroReajuste',
                //     label: 'R$ Unit. Reajustado',
                //     filterable: true,
                //     sortable: true,
                //     tdClass: 'text-right text-nowrap'
                // },
                {
                    key: 'valorTotal',
                    label: 'R$ Total',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-right text-nowrap'
                },
                {
                    key: 'qtdeSaldo',
                    label: 'Qtde. Saldo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-right text-nowrap'
                },
                {
                    key: 'rSaldo',
                    label: 'R$ Saldo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-right text-nowrap'
                },
                {
                    key: 'percentualExecutado',
                    label: '% Executado',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-right text-nowrap'
                },
                // {
                //     key: 'acoes',
                //     label: 'Ações',
                //     tdClass: 'text-center'
                // }
            ],
            mostrarModalAprovarItem: false,
            mostrarModalDevolverItem: false,
            itemBoletimMedicaoSelecionado: null,
            modoVisualizacaoImportacaoPdfAssinado: 'preview',
            documentoPdfGeradoParaAssinatura: null,
            carregandoPdfParaAssinatura: false,
            gerandoPdfPlanilhaMedicao: false,
            etapaBoletimMedicaoEnum: etapaBoletimMedicaoEnum,
        }
    },

    computed: {
        camposTabelaAtivos() {
            return this.camposTabela;
        },

        totalPorItemAgrupador() {
            const itens = this.boletimMedicao?.itens || [];
            const extrairCodigo = (descricao) => {
                const match = (descricao || '').match(/^([\d.]+)/);
                return match ? match[1] : null;
            };
            const totais = {};
            itens.forEach(item => {
                if (item.valorUnitario) return;
                const codigoPai = extrairCodigo(item.descricao);
                if (!codigoPai) return;
                totais[item.itemBoletimMedicaoId] = itens
                    .filter(filho => {
                        if (!filho.valorUnitario) return false;
                        const codigoFilho = extrairCodigo(filho.descricao);
                        return codigoFilho && codigoFilho.startsWith(codigoPai + '.');
                    })
                    .reduce((acc, filho) => acc + (filho.valorTotal || 0), 0);
            });
            return totais;
        },

        itensOrdenados() {
            if (!this.boletimMedicao?.itens) return [];
            return [...this.boletimMedicao.itens].sort((a, b) =>
                (a.descricao || '').localeCompare(b.descricao || '', undefined, { numeric: true, sensitivity: 'base' })
            );
        },

        habilitarExclusaoItens() {
            return this.boletimEditavel
        },
        podeGerarPdfParaAssinatura() {
            return (this.$store.getters.isFornecedor && this.boletimMedicao.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor)
                || (this.$store.getters.isFornecedor && this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor && this.boletimMedicao.planilhaMedicaoEditavel);
        },
        textoBotaoFluxoAssinatura() {
            return 'Gerar PDF para Assinatura';
        },
        anexoItensBoletimMedicaoPdf() {
            return this.boletimMedicao.anexos ? this.boletimMedicao.anexos.find(anexo =>
                anexo.tipoAnexoBoletimMedicao === tipoAnexoBoletimMedicaoEnum.MedicaoNaoAssinada
                || anexo.tipoAnexoBoletimMedicao === tipoAnexoBoletimMedicaoEnum.MedicaoAssinadaPeloFornecedor
                || anexo.tipoAnexoBoletimMedicao === tipoAnexoBoletimMedicaoEnum.MedicaoAssinadaPeloFiscalTerceiro
                || anexo.tipoAnexoBoletimMedicao === tipoAnexoBoletimMedicaoEnum.MedicaoAssinadaPeloFiscalObras
            ) : null;
        },
        documentoItensBoletimMedicaoParaFluxoPdf() {
            return this.documentoPdfGeradoParaAssinatura || this.anexoItensBoletimMedicaoPdf;
        },
        documentoMedicaoTipoAtual() {
            const tipo = this.obterTipoAnexoBoletimMedicao();
            return (this.boletimMedicao.anexos || []).find(a => a.tipoAnexoBoletimMedicao === tipo) || null;
        },
        mostrarBotaoAprovarParaColetaAssinaturaFiscalTerceiro() {
            return (this.boletimMedicao.contrato.possuiFiscalExterno
                && this.boletimMedicao.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor
                && this.$store.getters.isFornecedor);
        },
        mostrarBotaoAnexarPdfAssinado() {
            return this.modoVisualizacaoItens == 'pdf'
                && this.modoVisualizacaoImportacaoPdfAssinado == 'preview'
                && this.podeGerenciarAssinaturaAtual
                && ((this.$store.getters.isFornecedor && this.boletimMedicao.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor)
                    || (this.$store.getters.isFornecedor && this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor && this.boletimMedicao.planilhaMedicaoEditavel)
                    || (this.$temAcessoView('FISCAL-TERCEIRO') && this.boletimMedicao.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalTerceiro));
        },
        podeGerenciarAssinaturaAtual() {
            return (this.$store.getters.isFornecedor && this.boletimMedicao.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor)
                || (this.$store.getters.isFornecedor && this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor && this.boletimMedicao.planilhaMedicaoEditavel)
                || (this.$temAcessoView('FISCAL-TERCEIRO') && this.boletimMedicao.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalTerceiro);
        },
        nomeAnexoAssinadoAtual() {
            if (this.$store.getters.isFornecedor && this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor) {
                const anexo = (this.boletimMedicao.anexos || []).find(a => a.tipoAnexoBoletimMedicao === tipoAnexoBoletimMedicaoEnum.MedicaoAssinadaPeloFornecedor);
                return anexo ? (anexo.nome || 'Arquivo já enviado') : null;
            }
            const tipoMap = {
                [statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor]: tipoAnexoBoletimMedicaoEnum.MedicaoAssinadaPeloFornecedor,
                [statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalTerceiro]: tipoAnexoBoletimMedicaoEnum.MedicaoAssinadaPeloFiscalTerceiro,
            };
            const tipo = tipoMap[this.boletimMedicao.status];
            if (!tipo) return null;
            const anexo = (this.boletimMedicao.anexos || []).find(a => a.tipoAnexoBoletimMedicao === tipo);
            return anexo ? (anexo.nome || 'Arquivo já enviado') : null;
        },
    },
    methods: {
        limpar() {
            this.subItemContrato = null;
            this.valorUnitario = null;
            this.quantidade = null;
            this.subTotal = null;
            this.desconto = null;
            this.valorTotal = null;
        },
        excluir(itemBoletimMedicaoId) {
            this.$emit('excluirItemBoletimMedicao', this.boletimMedicao.boletimMedicaoId, itemBoletimMedicaoId);
        },
        confirmarExcluir(itemBoletimMedicaoId) {
            this.$swal({
                title: 'Exclusão de item da medição',
                html: `Confirma a exclusão do item da medição?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir(itemBoletimMedicaoId)
                }
            })
        },

        aprovarItem(itemBoletimMedicao) {
            this.itemBoletimMedicaoSelecionado = itemBoletimMedicao;
            this.mostrarModalAprovarItem = true;
        },

        devolverItem(itemBoletimMedicao) {
            this.itemBoletimMedicaoSelecionado = itemBoletimMedicao;
            this.mostrarModalDevolverItem = true;
        },

        habilitarBotaoDevolverItem(itemBoletimMedicao) {
            return (
                !this.$store.getters.isFornecedor
                && (
                    (
                        this.boletimMedicao.status === statusBoletimMedicaoEnum.EnviadoParaAprovacaoFiscalTerceiro
                        && this.$temAcessoView('FISCAL-TERCEIRO')
                        && itemBoletimMedicao.status === statusItemBoletimMedicaoEnum.AguardandoAprovacaoFiscalTerceiro
                    )
                    || (
                        this.boletimMedicao.status === statusBoletimMedicaoEnum.EnviadoParaAprovacaoFiscalObras
                        && (this.contrato.usuarioEhFiscalObra || this.contrato.usuarioEhOrdenador)
                        && (
                            itemBoletimMedicao.status === null /* quando o contrato não possui fiscal externo */
                            || itemBoletimMedicao.status === statusItemBoletimMedicaoEnum.AguardandoAprovacaoFiscalObras
                        )
                    )
                )
            );
        },

        habilitarBotaoAprovarItem(itemBoletimMedicao) {
            return (
                !this.$store.getters.isFornecedor
                && (
                    (
                        this.boletimMedicao.status === statusBoletimMedicaoEnum.EnviadoParaAprovacaoFiscalTerceiro
                        && this.$temAcessoView('FISCAL-TERCEIRO')
                        && itemBoletimMedicao.status === statusItemBoletimMedicaoEnum.AguardandoAprovacaoFiscalTerceiro
                    )
                    || (
                        this.boletimMedicao.status === statusBoletimMedicaoEnum.EnviadoParaAprovacaoFiscalObras
                        && (this.contrato.usuarioEhFiscalObra || this.contrato.usuarioEhOrdenador)
                        && (
                            itemBoletimMedicao.status === null /* quando o contrato não possui fiscal externo */
                            || itemBoletimMedicao.status === statusItemBoletimMedicaoEnum.AguardandoAprovacaoFiscalObras
                        )
                    )
                )
            );
        },

        mostrarIconeStatusItemBoletimMedicao(itemBoletimMedicao) {
            return !this.habilitarBotaoDevolverItem(itemBoletimMedicao)
                && !this.habilitarBotaoAprovarItem(itemBoletimMedicao)
                && itemBoletimMedicao.status != null;
        },

        fecharModalAprovarItem() {
            this.mostrarModalAprovarItem = false;
            this.itemBoletimMedicaoSelecionado = null;
            this.$emit('recarregarDadosBoletim');
        },

        fecharModalDevolverItem() {
            this.mostrarModalDevolverItem = false;
            this.itemBoletimMedicaoSelecionado = null;
            this.$emit('recarregarDadosBoletim');
        },

        mensagemStatusItem(itemBoletimMedicao) {
            return itemBoletimMedicao.justificativaReprovacao ? itemBoletimMedicao.justificativaReprovacao : itemBoletimMedicao.statusDescricao;
        },

        async onVisualizarFormatoPdfClick() {
            if (!this.podeGerarPdfParaAssinatura || this.carregandoPdfParaAssinatura) {
                return;
            }

            if (this.podeGerenciarAssinaturaAtual && this.nomeAnexoAssinadoAtual) {
                this.modoVisualizacaoItens = 'pdf';
                this.modoVisualizacaoImportacaoPdfAssinado = 'upload';
                return;
            }

            this.modoVisualizacaoImportacaoPdfAssinado = 'preview';
            const pdfGerado = await this.gerarPdfItensBoletimMedicaoParaAssinatura();

            if (!pdfGerado || !this.documentoItensBoletimMedicaoParaFluxoPdf) {
                return;
            }

            this.modoVisualizacaoItens = 'pdf';
        },

        async onVoltarFluxoPdfClick() {
            if (this.modoVisualizacaoImportacaoPdfAssinado === 'upload') {
                this.modoVisualizacaoImportacaoPdfAssinado = 'preview';
                await this.gerarPdfItensBoletimMedicaoParaAssinatura();
                return;
            }

            this.modoVisualizacaoItens = 'tabela';
            this.modoVisualizacaoImportacaoPdfAssinado = 'preview';
            this.documentoPdfGeradoParaAssinatura = null;
        },

        onProximaEtapaPdfClick() {
            this.modoVisualizacaoImportacaoPdfAssinado = 'upload';
        },

        converterBase64EmArrayBytes(base64) {
            const binaryString = atob(base64);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes;
        },

        converterBlobEmBase64(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const resultado = reader.result || '';
                    const base64 = resultado.toString().split(',')[1] || '';
                    resolve(base64);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },

        normalizarParteNomeArquivo(valor, fallback = '') {
            const texto = (valor || '').toString().trim();
            if (!texto) return fallback;

            const semAcento = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            const limpo = semAcento
                .replace(/[\\/:*?"<>|]+/g, '_')
                .replace(/\s+/g, '_')
                .replace(/_+/g, '_')
                .replace(/^[_\.]+|[_\.]+$/g, '');

            return limpo || fallback;
        },

        montarNomeArquivoPlanilhaMedicao() {
            const nomeBm = this.normalizarParteNomeArquivo(
                this.boletimMedicao?.numero || this.boletimMedicao?.nome,
                'BM'
            );
            const numeroContrato = this.normalizarParteNomeArquivo(
                this.contrato?.codContrato,
                'Contrato'
            );

            return `PlanilhaMedicao_${nomeBm}_${numeroContrato}.pdf`;
        },

        classeCabecalhoPdf(campo) {
            return (campo.tdClass || '').replace(/\btext-nowrap\b/g, '').trim();
        },

        larguraColunaPdf(campo) {
            const larguras = {
                descricao: '35%',
                valorUnitario: '7%',
                valorUnitarioMaisPrimeiroReajuste: '8%',
                valorFinanceiro: '8%',
                quantidadeContratada: '7%',
                quantidade: '6%',
                quantidadeAcumulada: '7%',
                unidadeMedida: '6%',
                valorTotal: '9%',
                percentualExecutado: '7%'
            };

            return larguras[campo.key] || '8%';
        },

        async gerarBlobPdfDaPlanilhaMedicao() {
            const contratoId = this.boletimMedicao?.contratoId || this.contrato?.contratoId;
            const boletimMedicaoId = this.boletimMedicao?.boletimMedicaoId;

            this.gerandoPdfPlanilhaMedicao = true;
            try {
                return await BoletimMedicaoServicos.gerarPdfItensBoletimMedicao(contratoId, boletimMedicaoId);
            } finally {
                this.gerandoPdfPlanilhaMedicao = false;
            }
        },

        async gerarPdfItensBoletimMedicaoParaAssinatura() {
            const contratoId = this.boletimMedicao?.contratoId || this.contrato?.contratoId;
            const boletimMedicaoId = this.boletimMedicao?.boletimMedicaoId;

            if (!contratoId || !boletimMedicaoId) return false;

            this.carregandoPdfParaAssinatura = true;
            this.$store.dispatch('addRequest');

            try {
                const blob = await this.gerarBlobPdfDaPlanilhaMedicao();

                if (!(blob instanceof Blob)) {
                    this.documentoPdfGeradoParaAssinatura = null;
                    this.$toast.error('Não foi possível gerar o PDF da planilha de medição.', 'Erro', {
                        position: 'topRight',
                        timeout: 5000
                    });
                    return false;
                }

                const base64 = await this.converterBlobEmBase64(blob);

                this.documentoPdfGeradoParaAssinatura = {
                    documentoBoletimMedicaoId: this.anexoItensBoletimMedicaoPdf?.documentoBoletimMedicaoId,
                    arquivo: base64,
                    nome: this.montarNomeArquivoPlanilhaMedicao()
                };

                this.$toast.success('PDF gerado com sucesso!', 'Sucesso', {
                    position: 'topRight',
                    timeout: 3000
                });

                return true;
            } catch (error) {
                this.documentoPdfGeradoParaAssinatura = null;
                this.$toast.error('Não foi possível gerar o PDF da planilha de medição.', 'Erro', {
                    position: 'topRight',
                    timeout: 5000
                });
                return false;
            } finally {
                this.carregandoPdfParaAssinatura = false;
                this.$store.dispatch('removeRequest');
            }
        },

        baixarPdf() {
            if (!this.documentoItensBoletimMedicaoParaFluxoPdf || !this.documentoItensBoletimMedicaoParaFluxoPdf.arquivo) {
                return;
            }

            const bytes = this.converterBase64EmArrayBytes(this.documentoItensBoletimMedicaoParaFluxoPdf.arquivo);
            const blob = new Blob([bytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            const nome = this.documentoItensBoletimMedicaoParaFluxoPdf.nome || this.montarNomeArquivoPlanilhaMedicao();

            link.href = url;
            link.download = nome.toLowerCase().endsWith('.pdf') ? nome : `${nome}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },

        onImportacaoPdfAssinadoImportacaoRealizada() {
            this.documentoPdfGeradoParaAssinatura = null;
            this.modoVisualizacaoImportacaoPdfAssinado = 'upload';
            this.$emit('recarregarDadosBoletim');
        },

        obterTipoAnexoBoletimMedicao() {
            switch (this.boletimMedicao.status) {
                case statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor:
                case statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor:
                    return tipoAnexoBoletimMedicaoEnum.MedicaoAssinadaPeloFornecedor;
                case statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalTerceiro:
                    return tipoAnexoBoletimMedicaoEnum.MedicaoAssinadaPeloFiscalTerceiro;
                default:
                    return tipoAnexoBoletimMedicaoEnum.MedicaoNaoAssinada;
            }
        },
    },
    mounted() {
        if (this.podeGerenciarAssinaturaAtual && this.nomeAnexoAssinadoAtual) {
            this.modoVisualizacaoItens = 'pdf';
            this.modoVisualizacaoImportacaoPdfAssinado = 'upload';
        }
    },
}
</script>

<style scoped>
.col-subitem-limited {
    max-width: 150px;
    white-space: normal;
    word-break: break-word;
}
.btn-blue-custom {
    background-color: #2E60AD !important;
    border-color: #2E60AD !important;
    color: #fff !important;
}
.btn-blue-custom:hover {
    filter: brightness(0.9);
}
.btn-green-custom {
    background-color: #23A26D !important;
    border-color: #23A26D !important;
    color: #fff !important;
}
.btn-green-custom:hover {
    filter: brightness(0.9);
}
.planilha-medicao-pdf-export {
    position: fixed;
    left: -10000px;
    top: 0;
    width: 1180px;
    background: #fff;
    color: #212529;
    padding: 0;
    z-index: -1;
}
.planilha-medicao-pdf-header {
    margin-bottom: 6px;
}
.planilha-medicao-pdf-export table {
    table-layout: fixed;
    font-size: 10.2px;
    line-height: 1.08;
}
.planilha-medicao-pdf-export th,
.planilha-medicao-pdf-export td {
    border-color: #dee2e6 !important;
    padding: 1px 1px !important;
    line-height: 1.08 !important;
}
.planilha-medicao-pdf-export thead th {
    background-color: #f8f9fa;
    color: #212529;
    white-space: normal;
    word-break: normal;
}
.col-descricao-pdf {
    white-space: normal;
    word-break: break-word;
}
.planilha-medicao-pdf-source {
    overflow-x: auto;
}
::v-deep #tblPlanilhaMedicao th:first-child,
::v-deep #tblPlanilhaMedicao td:first-child {
    position: sticky;
    left: 0;
    z-index: 2;
    background-color: #fff;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);
}
::v-deep #tblPlanilhaMedicao thead th:first-child {
    background-color: #f8f9fa;
    z-index: 3;
}
::v-deep #tblPlanilhaMedicao tbody tr:nth-of-type(odd) td:first-child {
    background-color: #f2f2f2;
}
.signature-section {
    width: 100%;
    margin-top: 42px;
    display: flex;
    justify-content: space-around;
    page-break-inside: avoid;
    break-inside: avoid;
}
.signature-box {
    display: inline-block;
    width: 45%;
    max-width: 360px;
    text-align: center;
    vertical-align: top;
    box-sizing: border-box;
    margin: 0 20px;
    page-break-inside: avoid;
    break-inside: avoid;
}
.signature-label {
    display: block;
    border-top: 1px solid #000;
    padding-top: 6px;
    font-size: 10.2px;
    font-weight: 600;
    page-break-inside: avoid;
    break-inside: avoid;
}
</style>
